export interface INavigationDirectionInfo {
    direction: number;
    north: number;
}

export interface INavigationInfo extends INavigationDirectionInfo {
    distance: number;
}

export const DEFAULT_NAVIGATION_INFO: INavigationInfo = {
    direction: 0,
    north: 0,
    distance: 0
};
